import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {UnderlineNav} from '@primer/react/drafts'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Simple`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<UnderlineNav aria-label="Repository">
  <UnderlineNav.Item selected>Item 1</UnderlineNav.Item>
  <UnderlineNav.Item>Item 2</UnderlineNav.Item>
  <UnderlineNav.Item>Item 3</UnderlineNav.Item>
</UnderlineNav>
`}</code></pre>
    <h3>{`With Icons`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<UnderlineNav aria-label="Repository">
  <UnderlineNav.Item selected icon={CodeIcon}>
    Code
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={IssueOpenedIcon} counter={30}>
    Issues
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={GitPullRequestIcon} counter={3}>
    Pull Requests
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={CommentDiscussionIcon}>Discussions</UnderlineNav.Item>
  <UnderlineNav.Item icon={EyeIcon} counter={9}>
    Actions
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={EyeIcon} counter={7}>
    Projects
  </UnderlineNav.Item>
</UnderlineNav>
`}</code></pre>
    <h3>{`Overflow Behaviour`}</h3>
    <p>{`When overflow occurs, the component first hides icons if present to optimize for space and show as many items as possible. (Only for fine pointer devices)`}</p>
    <h4>{`Items Without Icons`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<UnderlineNav aria-label="Repository">
  <UnderlineNav.Item selected icon={CodeIcon}>
    Code
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={IssueOpenedIcon} counter={30}>
    Issues
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={GitPullRequestIcon} counter={3}>
    Pull Requests
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={CommentDiscussionIcon}>Discussions</UnderlineNav.Item>
  <UnderlineNav.Item icon={PlayIcon} counter={9}>
    Actions
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={ProjectIcon} counter={7}>
    Projects
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={ShieldLockIcon}>Security</UnderlineNav.Item>
  <UnderlineNav.Item icon={GraphIcon}>Insights</UnderlineNav.Item>
  <UnderlineNav.Item icon={GearIcon} counter={1}>
    Settings
  </UnderlineNav.Item>
</UnderlineNav>
`}</code></pre>
    <h4>{`Display `}<inlineCode parentName="h4">{`More`}</inlineCode>{` Menu`}</h4>
    <p>{`If there is still overflow, the component will behave depending on the pointer.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<UnderlineNav aria-label="Repository">
  <UnderlineNav.Item selected icon={CodeIcon}>
    Code
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={IssueOpenedIcon} counter={30}>
    Issues
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={GitPullRequestIcon} counter={3}>
    Pull Requests
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={CommentDiscussionIcon}>Discussions</UnderlineNav.Item>
  <UnderlineNav.Item icon={EyeIcon} counter={9}>
    Actions
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={EyeIcon} counter={7}>
    Projects
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={EyeIcon}>Security</UnderlineNav.Item>
  <UnderlineNav.Item icon={EyeIcon} counter={14}>
    Insights
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={EyeIcon} counter={1}>
    Settings
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={EyeIcon}>Wiki</UnderlineNav.Item>
</UnderlineNav>
`}</code></pre>
    <h3>{`Loading state for counters`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<UnderlineNav aria-label="Repository" loadingCounters={true}>
  <UnderlineNav.Item counter={4} selected>
    Item 1
  </UnderlineNav.Item>
  <UnderlineNav.Item counter={44}>Item 2</UnderlineNav.Item>
  <UnderlineNav.Item>Item 3</UnderlineNav.Item>
</UnderlineNav>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`UnderlineNav`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="aria-label" type="string" description="A unique name for the rendered 'nav' landmark. It will also be used to label the arrow buttons that control the scroll behaviour on coarse pointer devices. (I.e. 'Scroll ${aria-label} left/right')" mdxType="PropsTableRow" />
  <PropsTableRow name="loadingCounters" type="boolean" defaultValue="false" description="Whether all of the counters are in loading state" mdxType="PropsTableRow" />
  <PropsTableRow name="afterSelect" type="(event) => void" description="The handler that gets called when a nav link child is selected" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`UnderlineNav.Item`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="icon" type="Component" description="The leading icon comes before item label" mdxType="PropsTableRow" />
  <PropsTableRow name="selected" type="boolean" description="Whether the link is selected" mdxType="PropsTableRow" />
  <PropsTableRow name="onSelect" type="(event) => void" description="The handler that gets called when a nav link is selected" mdxType="PropsTableRow" />
  <PropsTableRow name="as" type="string | Component" defaultValue="a" description="What kind of component needs to be rendered" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: false,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      